import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { BrandingResponse } from '../interfaces';
import { useContext } from 'react';
import { FetchBrandThemingContext } from '../Context';

export const useFetchBrandingQuery = (options: Options = {}) => {

  const fetchBranding = useContext(FetchBrandThemingContext);

  const query = useQuery({
    queryKey: [`get:groups/branding`, fetchBranding],
    queryFn: () => {
      return fetchBranding();
    },
    ...options,
  });

  return query;
};

type Options = Omit<UseQueryOptions<BrandingResponse>, 'queryKey' | 'queryFn'>;